export default class soundManager {
    constructor(manager){

        //manager
        this.manager = manager;

        //dom
        this.$soundIcon = document.getElementById('l-footer__sound');

        this.sound;

        this.status = {
            play:false,
        }

    }
    init(){

        if(Useragnt.mobile || this.manager.isIpad) return;

        let _sound = new Audio();
        _sound.src = '/chorus/assets/sound.mp3';
        _sound.volume = 1.0;
        _sound.autoplay = true;
        _sound.loop = true;

        this.sound = _sound;

        this.status.play = true;
        this.$soundIcon.classList.remove('is-pause');
        this.$soundIcon.classList.add('is-play');

        this.$soundIcon.addEventListener("click",()=>{
            if(this.status.play){
                this.Pause();
            }else{
                this.Play();
            }
        });

    }

    Play(){

        this.status.play = true;

        this.sound.play();
        this.$soundIcon.classList.remove('is-pause');
        this.$soundIcon.classList.add('is-play');

    }

    Pause(){

        this.status.play = false;

        this.sound.pause();
        this.$soundIcon.classList.add('is-pause');
        this.$soundIcon.classList.remove('is-play');

    }


}